import { SidePaneScaffold } from "./SidePaneScaffold";
import { 마켓봄_장점_Desktop } from "./마켓봄_장점_Desktop";
import { 마켓봄_장점_리드_Desktop } from "./마켓봄_장점_리드_Desktop";
import * as 마켓봄피쳐 from "./데이터/마켓봄피쳐";
import { 푸터_Desktop } from "./푸터_Desktop";

export type 마켓봄_장점과_리드_Desktop_Props = {
  마켓봄피쳐목록: readonly 마켓봄피쳐.마켓봄피쳐[];
};

export const 마켓봄_장점과_리드_Desktop = ({
  마켓봄피쳐목록,
}: 마켓봄_장점과_리드_Desktop_Props) => {
  return (
    <>
      <SidePaneScaffold
        content={<마켓봄_장점_Desktop 선택된_목록={마켓봄피쳐목록} />}
        sidePane={<마켓봄_장점_리드_Desktop 선택된_목록={마켓봄피쳐목록} />}
      />
      <푸터_Desktop />
    </>
  );
};
